import { render, staticRenderFns } from "./biaozhu.vue?vue&type=template&id=3b0832cd&scoped=true&"
import script from "./biaozhu.vue?vue&type=script&lang=ts&"
export * from "./biaozhu.vue?vue&type=script&lang=ts&"
import style0 from "./biaozhu.vue?vue&type=style&index=0&id=3b0832cd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0832cd",
  null
  
)

export default component.exports